import React, { useState, useEffect, useRef } from 'react';
import { DialogContentText } from '@material-ui/core';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import { Document, Page, pdfjs } from 'react-pdf';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  MenuItem,
  TextField,
  DialogActions,
  Checkbox,
  FormControlLabel,
  FormLabel,
  Typography,
  Grid,
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import Select from 'react-select';
import PDFSingleViewer from '../../../../components/PDFSingleViewer';
import ImgSingleViewer from '../../../../components/ImgSingleViewer';
import {
  makeS3BlobsRenderable,
  fileSelectHandler,
} from '../../../../util/fileHandling';
import Button from '../../../../components/Button';
import ProviderSearchBar from '../../../../components/ProviderSearchBar';
import TimeSelect from '../../../../components/TimeSelect';
import PatientSearchBar from '../../../../components/PatientSearchBar';
import * as api from '../../../../services/api/admin';
import * as authApi from '../../../../services/api/auth';
import DateSelect from '../../../../components/DateSelect';
import NoticeDialog from '../../../../components/DialogModals/NoticeDialog';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${
  pdfjs.version
}/pdf.worker.js`;
const options = {
  cMapUrl: 'cmaps/',
  cMapPacked: true,
};

function CreateAppointmentModal(props) {
  const {
    open,
    onSubmit,
    onClose,
    overBookAlert,
    // openDuplicateApptAlert,
    // closeDuplicateApptAlert,
    closeAlert,
    classes: {
      modal,
      selectInput,
      modalContent,
      input,
      dialogFooter,
      warning,
      previewImg,            
      button,
      btnCenter,
    },
  } = props;

  const [currentUser, setCurrentUser] = useState({});
  const [currentPatient, setCurrentPatient] = useState({});
  const [selectedProvider, setSelectedProvider] = useState({});
  const [specialties, setSpecialties] = useState([]);
  const [currentSpecialty, setCurrentSpecialty] = useState(null);
  const [tenancyList, setTenancyList] = useState([]);
  const [currentTenancyId, setCurrentTenancyId] = useState('');
  const [formInfoConfirmed, setFormInfoConfirmed] = useState(false);
  const [portalNotes, setPortalNotes] = useState('');
  const [date, setDate] = useState(
    moment()
      .tz('America/New_York')
      .format('MM/DD/YYYY')
  );
  const [time, setTime] = useState(null);
  const [validationErrors, setValidationErrors] = useState({});
  const [fromProvider, setFromProvider] = useState({});
  const [conciergeMode, setConcierge] = useState(false);

  const [images, setImages] = useState([]);
  const [openPDFModal, setOpenPDFModal] = useState(false);
  const [openImgModal, setOpenImgModal] = useState(false);
  const [currentPDF, setCurrentPDF] = useState([]);
  const [currentImg, setCurrentImg] = useState('');
  const [imagePreview, setImagePreview] = React.useState(true);
  const [popNotice, setPopNotice] = useState('');
  const myRef = useRef(null);

  // loading appropriate tenancies when current provider is updated
  useEffect(() => {
    (async () => {
      setCurrentUser(await authApi.fetchCurrentUser());
    })();
    if (selectedProvider.id) {
      (async () => {
        if (
          selectedProvider.fullTitle === 'Qwell Concierge Recommendations' ||
          selectedProvider.fullTitle ===
            'Qwell Lexington Medical Associates Recommendations'
        ) {
          setConcierge(true);
          if (!specialties.length) {
            const fetchedSpecialties = await api.fetchSpecialties();
            setSpecialties(fetchedSpecialties);
          }
        } else {
          setConcierge(false);
          if (currentSpecialty) {
            setCurrentSpecialty(null);
          }
        }
        const tenancies = await api.fetchTenancies(selectedProvider.id);
        setTenancyList(
          tenancies.map(tenancy => ({
            value: tenancy.id,
            label: tenancy.location,
          }))
        );
        setCurrentTenancyId(tenancies[0].id);
      })();
    }
  }, [selectedProvider]);

  const chooseFromList = objType => chosenObj => {
    if (objType === 'patient') {
      setCurrentPatient(chosenObj || {});
    }
    if (objType === 'provider') {
      setSelectedProvider(chosenObj || {});
    }
    if (objType === 'tenancy') {
      setCurrentTenancyId(chosenObj.target.value);
    }
    setValidationErrors({ ...validationErrors, [objType]: false });
  };

  const changeDate = date => {
    if (date) {
      setDate(date.tz('America/New_York').format('MM/DD/YYYY'));
      setValidationErrors({ ...validationErrors, date: false });
    }
  };

  const changeTime = event => {
    const nextTime = moment(event.target.value);
    if (nextTime) {
      setTime(nextTime.toISOString());
      setValidationErrors({ ...validationErrors, time: false });
    }
  };

  const callSetImage = event => {
    setImages([]);
    fileSelectHandler(
      event.target.files,
      inputPicCallBack,
      ['jpg', 'jpeg', 'pdf'],
      1048576 // 1048576 bytes = 1MBl
    );
  };

  const handleOpenImg = link => {
    setOpenImgModal(true);
    setCurrentImg(link);
  };
  const handleOpenPDF = link => {
    setOpenPDFModal(true);
    setCurrentPDF(link);
  };

  // const inputPicCallBack = fileObject => {
  //   const [fileObjectOrStatusCode] = fileObject;
  //   if (fileObjectOrStatusCode < 0 && fileObjectOrStatusCode >= -2) {
  //     const notice = (fileObjectOrStatusCode === -1)? 'Max file size is 2MB' : 'Please use a valid file to upload';
  //     setPopNotice(notice);
  //   } else {
  //     setImages([
  //       ...[],
  //       fileObjectOrStatusCode,
  //     ])
  //   }
  // }

  const inputPicCallBack = fileObject => {
    setImages(fileObject);
    fileObject.map(fileObjectOrStatusCode => {
      if (fileObjectOrStatusCode < 0 && fileObjectOrStatusCode >= -2) {
        const notice =
          fileObjectOrStatusCode === -1
            ? 'Max file size is 2MB'
            : 'Please use a valid file to upload';
        setPopNotice(notice);
        myRef.current.value = null;
        setImages([]);
      }
    });
  };

  const validate = () => {
    let valid = true;
    let nextState = {};
    if (!conciergeMode && !formInfoConfirmed) {
      nextState.confirmed = 'Required';
      valid = false;
    } else {
      if (!currentPatient.id) {
        valid = false;
        nextState.patient = 'Required';
      }
      if (!selectedProvider) {
        valid = false;
        nextState.provider = 'Required';
      }
      if (!currentTenancyId) {
        valid = false;
        nextState.tenancy = 'Required';
      }
      if (!date) {
        valid = false;
        nextState.date = 'Required';
      }
      if (!time) {
        valid = false;
        nextState.time = 'Required';
      }
      if (!portalNotes) {
        valid = false;
        nextState.portalNotes = 'Required';
      }
    }
    setValidationErrors(nextState);
    return valid;
  };

  const save = async () => {
    const apptTime = moment(
      moment(date).format('MM/DD/YYYY') + ' ' + moment(time).format('HH:mm')
    ).toISOString();
    const isApptBooked = await onSubmit({
      fromProviderUserId: currentUser.isAdministrator
        ? fromProvider.userId
        : currentUser.isProvider
        ? currentUser.id
        : null,
      tenancyId: currentTenancyId,
      patientEmail: currentPatient.email,
      providerId: selectedProvider.id,
      time: apptTime,
      attachments: images.map(i => i.dataUrl),
      portalNotes: currentSpecialty
        ? `specialty: ${currentSpecialty.label}\n` + portalNotes
        : portalNotes,
    });

    // reset state
    if(isApptBooked){
    setCurrentPatient({});
    setSelectedProvider({});
    setConcierge(false);
    setCurrentSpecialty(null);
    setSpecialties([]);
    setCurrentTenancyId('');
    setDate(null);
    setTime(null);
    setPortalNotes('');
    setFormInfoConfirmed(false);
    setTenancyList([]);
    onClose();
    }
  };

  // const closeModel = ()=>{
  //   setCurrentPatient({});
  //   setSelectedProvider({});
  //   setConcierge(false);
  //   setCurrentSpecialty(null);
  //   setSpecialties([]);
  //   setCurrentTenancyId('');
  //   setDate(null);
  //   setTime(null);
  //   setPortalNotes('');
  //   setFormInfoConfirmed(false);
  //   setTenancyList([]);
  //   onClose();
  // }

  return (
    <Dialog fullWidth open={open} onClose={onClose} classes={{ paper: modal }}>
      <DialogTitle>
        <span style={{ fontSize: '1.5em', fontWeight: 'bold' }}>
          Create a new appointment
        </span>
      </DialogTitle>

      <DialogContent classes={{ root: modalContent }}>
        <PatientSearchBar
          onSelect={chooseFromList('patient')}
          errorMessage={validationErrors.patient}
        />

        <ProviderSearchBar
          clearable={false}
          label="For Provider"
          name="provider"
          placeholder="Search for a provider..."
          onSelect={chooseFromList('provider')}
          className={selectInput}
          errorMessage={validationErrors.provider}
        />
        {conciergeMode && (
          <Select
            fullWidth
            isSearchable
            isClearable
            aria-label="Specialty"
            placeholder="Specialty"
            value={currentSpecialty}
            onChange={setCurrentSpecialty}
            options={[
              ...specialties.map((specialty) => ({
                value: specialty.shortName,
                label: specialty.name,
              })),
            ]}
            styles={{
              menu: (base) => ({
                ...base,
                zIndex: '999',
              }),
              menuList: (base) => ({
                ...base,
                zIndex: '999',
              }),
            }}
            className={input}
          />
        )}
        {currentUser.isAdministrator && (
          <ProviderSearchBar
            clearable={false}
            label="On Behalf Of (Provider)"
            name="fromProvider"
            placeholder="Search for a provider..."
            practiceId="currentUsersPracticeId"
            onSelect={(provider) => {
              setValidationErrors({ ...validationErrors, fromProvider: false });
              setFromProvider(provider);
            }}
            errorMessage={validationErrors.fromProvider}
            className={selectInput}
          />
        )}

        <TextField
          disabled={
            !selectedProvider || conciergeMode || tenancyList.length < 2
          }
          fullWidth
          variant="outlined"
          label="Location"
          name="tenancy"
          select
          value={currentTenancyId}
          onChange={chooseFromList('tenancy')}
          error={validationErrors.tenancy}
          helperText={validationErrors.tenancy}
          className={selectInput}
        >
          {tenancyList.map((tenancy) => (
            <MenuItem key={`menu-${tenancy.value}`} value={tenancy.value}>
              {tenancy.label}
            </MenuItem>
          ))}
        </TextField>

        <DateSelect
          fullWidth
          variant="outlined"
          label="Date"
          format="MM/DD/YYYY"
          disablePast={currentUser && currentUser.admin ? false : true}
          placeholder="MM/DD/YYYY ex. 01/01/2001"
          value={moment(date).tz('America/New_York')}
          onChange={changeDate}
          error={validationErrors.date}
          helperText={validationErrors.date}
          className={input}
        />

        <TimeSelect
          fullWidth
          label="Time"
          time={time}
          onChange={changeTime}
          error={validationErrors.time}
          helperText={validationErrors.time}
          className={input}
        />

        <Dialog
          open={overBookAlert}
          onClose={closeAlert}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              An appointment has already been booked for this slot. Please
              choose some other available slot.
            </DialogContentText>
            <div className={btnCenter}>
              <Button
                onClick={closeAlert}
                variant="contained"
                color="primary"
                className={button}
              >
                Ok
              </Button>
            </div>
          </DialogContent>
        </Dialog>

        {/* Restrict dupliacte appointments for the same day */}
        {/* <Dialog
          open={openDuplicateApptAlert}
          onClose={closeDuplicateApptAlert}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
            An appointment has already been booked for this patient on the given date. Please return to schedule and select another day to book appointment.
            </DialogContentText>
            <div className={btnCenter}>
              <Button
                onClick={closeDuplicateApptAlert}
                variant="contained"
                color="primary"
                className={button}
              >
                Ok
              </Button>
            </div>
          </DialogContent>
        </Dialog>
*/}
        {/* <div style={{ width: '100%', textAlign: 'center' }}>
          <CircularProgress size="90px" />
        </div> */}
        <TextField
          fullWidth
          multiline
          rows="5"
          variant="outlined"
          label="Notes/Portal-Reason"
          name="portalNotes"
          value={portalNotes}
          error={validationErrors.portalNotes}
          helperText={validationErrors.portalNotes}
          className={input}
          onChange={(event) => setPortalNotes(event.target.value)}
        />
        {/* Added file attachment */}
        <FormLabel component="legend">Add attachments</FormLabel>
        <input
          type="file"
          ref={myRef}
          multiple
          onChange={(event) => callSetImage(event)}
        />

        {images && images.length > 0 ? (
          <div>{images.length} images attached</div>
        ) : (
          images.map((image, index) =>
            image?.fileType === 'pdf' ? (
              <>
                <Button
                  color="primary"
                  variant="contained"
                  onClick={() => handleOpenPDF(image.dataUrl)}
                >
                  Click to Preview
                </Button>

                {/* <Document file={image.dataUrl} options={options} className={previewImg}>
                    <Page pageNumber={1} />
                  </Document> */}

                <PDFSingleViewer
                  openPDFModal={openPDFModal}
                  currentPDF={currentPDF}
                  onClose={() => setOpenPDFModal(false)}
                />
              </>
            ) : (
              <Grid container item xs={12}>
                <Grid item xs={12}>
                  <Button
                    disabled={!imagePreview}
                    color="primary"
                    variant="contained"
                    onClick={() => handleOpenImg(image.dataUrl)}
                  >
                    Click to Preview
                  </Button>
                  <a
                    className="popup-download-btn"
                    target="_blank"
                    href={image && image.dataUrl}
                    download
                  >
                    Download
                  </a>
                </Grid>

                {/* <img src={ image && image.dataUrl} key={`picture-${index}`} onError={()=>setImagePreview(false)} alt="To see full report, please download the file" className={previewImg} /> */}
                <ImgSingleViewer
                  openImgModal={openImgModal}
                  currentImg={currentImg}
                  onClose={() => setOpenImgModal(false)}
                />
              </Grid>
            )
          )
        )}
        {popNotice && (
          <NoticeDialog
            open={popNotice}
            onOkClick={() => setPopNotice('')}
            noticeTitle="Notice"
            message={popNotice}
          />
        )}

        {!conciergeMode && (
          <FormControlLabel
            control={
              <Checkbox
                checked={formInfoConfirmed}
                onChange={() => {
                  setFormInfoConfirmed(!formInfoConfirmed);
                  setValidationErrors({
                    ...validationErrors,
                    confirmed: formInfoConfirmed ? 'Required' : false,
                  });
                }}
                value="primary"
                inputProps={{ 'aria-label': 'primary checkbox' }}
              />
            }
            label={`I have confirmed with ${
              selectedProvider.fullTitle
                ? selectedProvider.fullTitle
                : 'this provider'
            } that I am booking this appointment.`}
          />
        )}
        {validationErrors.confirmed && (
          <Typography className={warning}>Required</Typography>
        )}
      </DialogContent>
      <DialogActions className={dialogFooter}>
        <Button onClick={onClose} variant="outlined" color="primary">
          Back
        </Button>

        <Button
          variant="contained"
          color="primary"
          onClick={save}
          onClickValidation={validate}
          disabledDuringOnClick={true}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}

CreateAppointmentModal.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

const styles = () => ({
  modal: {
    maxHeight: '700px',
  },
  selectInput: {
    marginTop: '0.5em',
    marginBottom: '1em',
  },
  modalContent: {
    overflow: 'visible',
  },
  input: {
    margin: '0.5em 0',
  },
  dialogFooter: {
    display: 'flex',
    justifyContent: 'space-between',
    color: '#ADADAD',
  },
  warning: {
    color: '#e25141',
    fontSize: '12px',
  },
  previewImg: {
    maxWidth: 300,
    maxHeight: 300,
  },
  button: {
    width: '100px',
    marginLeft: 'auto',
    marginRight: 'auto',
    marginTop: '0px',
    marginBottom: '15px',
  },
  btnCenter: {
    display: 'flex',
    alignItems: 'center'

  }
});

export default withStyles(styles)(CreateAppointmentModal);
